import Vue from 'vue';
import  VueRecaptcha  from 'vue-recaptcha';
Vue.component("v-recaptcha", VueRecaptcha);

export default ({
});